import { Link } from "react-router-dom";
import bandflowLogo from "@/assets/bandflow-logo.png";

export function Footer() {
  return (
    <footer className="border-t bg-secondary py-10">
      <div className="container">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block min-w-[44px] min-h-[44px]">
              <img src={bandflowLogo} alt="Bandflow" className="h-6 w-auto" width={111} height={24} />
            </Link>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
              El directorio colaborativo de salas de conciertos en España. Busca, compara y comparte tu experiencia.
            </p>
          </div>

          {/* About */}
          <div>
            <h4 className="font-display text-sm font-semibold mb-3">Sobre nosotros</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/" className="hover:text-foreground transition-colors">Quiénes somos</Link></li>
              <li><Link to="/" className="hover:text-foreground transition-colors">Cómo funciona</Link></li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="font-display text-sm font-semibold mb-3">Ayuda</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/contacto" className="hover:text-foreground transition-colors">Contacto</Link></li>
              <li><Link to="/" className="hover:text-foreground transition-colors">Añadir una sala</Link></li>
              <li><Link to="/" className="hover:text-foreground transition-colors">Preguntas frecuentes</Link></li>
              <li><Link to="/" className="hover:text-foreground transition-colors">Términos de uso</Link></li>
              <li><Link to="/" className="hover:text-foreground transition-colors">Privacidad</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 border-t pt-6 text-center text-xs text-muted-foreground md:flex-row md:justify-between md:text-left">
          <p>© {new Date().getFullYear()} Bandflow</p>
          <div className="flex items-center gap-4">
            <p>Hecho para la comunidad musical española</p>
            <Link to="/admin/login" className="hover:text-foreground transition-colors">
              Acceso administración
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
